import React, { lazy, Suspense } from 'react'
import { TaskService } from '@duck/api-definitions'
import { useTar } from '@/modules'
import { StandardLoader } from '@/components/StandardLoader'

const CodeInput = lazy(() => import('../DataWorkspace/CodeInput').then(module => ({ default: module.CodeInput })))

interface PayloadSectionProps {
  formData: Partial<TaskService.Task>
  onChange: (field: keyof TaskService.Task, value: string | number | string[] | TaskService.TaskWeaponsOfChoiceEnum[] | boolean | undefined) => void
  fieldErrors?: Record<string, string>
}

export const PayloadSection: React.FC<PayloadSectionProps> = ({
  formData,
  onChange,
  fieldErrors = {},
}) => {
  const { t } = useTar()

  return (
    <div className="space-y-6">
      {/* Feedback Payload */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-foreground border-b border-border pb-2">
          {t('tasks.feedbackPayload')}
        </h3>
        {formData.isSandboxTask && (
          <p className="text-sm text-muted-foreground">{t('tasks.feedbackPayloadOptionalForSandbox')}</p>
        )}
        <div className="space-y-2 flex flex-col h-[540px]">
          <Suspense fallback={
            <div className="border border-border pt-2 bg-background h-[280px] flex items-center justify-center">
              <StandardLoader size="md" />
            </div>
          }>
            <CodeInput
              query={formData.feedbackPayload ?? ''}
              onQueryChange={(val) => onChange('feedbackPayload', val)}
              language={'JSON'}
            />
          </Suspense>
          {fieldErrors.feedbackPayload && (
            <p className="text-sm text-error mt-1">{fieldErrors.feedbackPayload}</p>
          )}
        </div>
      </div>
    </div>
  )
}
